import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';
import IdListDTO from 'models/dto/IdListDTO';
import TaskDTO from 'models/dto/tasks/taskDTO';
import Task from 'models/tasks/task';
import { CopilotConversation } from '../../copilotConversation';
import { TenantProcessStatus } from '../../tenantProcessStateBase';

// What a finding said before the proposal, so the preview can show the current version next to the
// proposed one.
export class AuditFindingOriginal {
  taskId: number;

  name: string;

  description?: string;

  checkList?: string;

  tagIds: number[];

  constructor() {
    this.taskId = -1;
    this.name = '';
    this.tagIds = [];
  }
}

export class AuditFindingOriginalDTO {
  taskId: number;

  name: string;

  description?: string;

  checkList?: string;

  tagIds?: IdListDTO;

  constructor() {
    this.taskId = -1;
    this.name = '';
  }
}

export class TenantProcessStateAuditFindings {
  internalAuditId: number;

  // proposed new findings; the template the user picks per card is kept on the task itself
  newTasks: Task[];

  // proposed rewrites of findings that already exist
  updatedTasks: Task[];

  originals: AuditFindingOriginal[];

  // the templates a new finding may be created from: task templates carrying a finding label
  eligibleTemplateIds: number[];

  // what the process is doing after this run: the analysis can complete on its own when there is
  // nothing to propose, and the panel has to stop presenting it as running
  status: TenantProcessStatus;

  conversation: CopilotConversation;

  constructor() {
    this.internalAuditId = 0;
    this.newTasks = [];
    this.updatedTasks = [];
    this.originals = [];
    this.eligibleTemplateIds = [];
    this.status = TenantProcessStatus.NotStarted;
    this.conversation = new CopilotConversation();
  }
}

export class TenantProcessStateAuditFindingsDTO {
  internalAuditId: number;

  newTasks: TaskDTO[];

  updatedTasks: TaskDTO[];

  originals: AuditFindingOriginalDTO[];

  eligibleTemplateIds: number[];

  conversation: CopilotConversationDTO;

  constructor() {
    this.internalAuditId = 0;
    this.newTasks = [];
    this.updatedTasks = [];
    this.originals = [];
    this.eligibleTemplateIds = [];
    this.conversation = new CopilotConversationDTO();
  }
}
